import { Component, ElementRef, Inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { applyStyles } from '../../../function/apply-styles.function';
import { CPopTemplateTextElement } from '../../../model/c-pop-template-text-element.model';
import { CMPS_EC_TEXT_ELEMENT } from '../../../model/metadata';

@Component({
    selector: 'cmps-event-centre-c-pop-text-v2',
    templateUrl: './text-v2.component.html',
    host: {
        class: 'cmps-event-centre-c-pop-text-v2 cmps-cdk-d-block',
    },
})
export class TextV2Component {
    /** @private */
    _html: SafeHtml;

    constructor(
        private readonly _el: ElementRef<HTMLElement>,
        private readonly _domSanitizer: DomSanitizer,
        /** @private */ @Inject(CMPS_EC_TEXT_ELEMENT)
        readonly _data: CPopTemplateTextElement,
    ) {
        applyStyles(this._el.nativeElement, this._data.styles);

        this._html = this._domSanitizer.bypassSecurityTrustHtml(_data.value);
    }
}
